import {Injectable, OnInit} from '@angular/core';
import {Payee} from '../models/payee.model';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../base.service';
import {Currency} from "../../models/latipay/currency.model";

@Injectable()
export class OrganisationAssessmentAnswerService extends BaseService implements OnInit {

    constructor(public http: HttpClient) {
        super('organisation-assessment-answer', http);
    }

    ngOnInit(): void {
    }
}